import { AuthService } from "@/services/Auth";
import Vue from "vue";
import VueI18n from 'vue-i18n'
import { Constantes } from "@/Util/Constantes";

Vue.use(VueI18n);

let locale = AuthService.getUsuario()?.language;

export default new VueI18n({
    locale: !!locale ? locale : "es-ES",
    //@ts-ignore
    dateTimeFormats: Constantes.dateTimeFormats,
    //@ts-ignore
    numberFormats: Constantes.numberFormats
  });
  